import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Dropdown, type IDropdownItem } from 'shared/ui'
import type { NewSavedReplyStore } from 'widgets/SavedReplies'
import styles from './styles.module.scss'

type ISavedReplyActionsProps = {
  newSavedReplyStore: NewSavedReplyStore
}

export const SavedReplyActions: FC<ISavedReplyActionsProps> = observer(({ newSavedReplyStore }) => {
  const {
    isPublic,
    setPublic,
    onCancel,
    onCreate,
    disabled,
    loading,
    isEdit,
    savedReplay,
    entitiesStore: {
      usersStore: { user },
    },
    savedRepliesStore: {
      canManageSavedReplies,
      savedRepliesPermissionError,
      savedReplyVisibilityText,
      savedReplyVisibilityIcon,
      handleChangeVisibilitySavedReplies,
    },
  } = newSavedReplyStore
  const onChange = (item: IDropdownItem) => {
    if (isEdit && savedReplay) {
      handleChangeVisibilitySavedReplies(savedReplay, item.id === 'everyone')
    } else {
      setPublic(item.id === 'everyone')
    }
  }

  return (
    <div className={styles.actions}>
      <Dropdown
        ariaLabel={'SavedReplyActions'}
        triggerComponent={(open) => (
          <Button
            text={isPublic ? 'All members' : savedReplyVisibilityText}
            active={open}
            typeBtn={'outlined'}
            contained={'secondary'}
            iconRight={'chevronDown'}
            size={'medium'}
            icon={isPublic ? 'users' : undefined}
            customIcon={user && !isPublic ? savedReplyVisibilityIcon : undefined}
          />
        )}
        placement={'bottom-start'}
        items={[
          {
            id: 'personal',
            label: savedReplyVisibilityText,
            customIconL: user ? savedReplyVisibilityIcon : undefined,
            activeValue: !isPublic,
            wrapLabel: 'Visibility',
          },
          {
            id: 'everyone',
            label: 'All members',
            iconL: 'users',
            activeValue: isPublic,
          },
        ]}
        disabled={!canManageSavedReplies}
        tooltipProps={{
          label: savedRepliesPermissionError,
          placement: 'top',
        }}
        onChange={onChange}
      />
      <div className={styles.right}>
        <Button
          text={'Cancel'}
          typeBtn={'contained'}
          contained={'secondary'}
          size={'medium'}
          onClick={onCancel}
        />
        <Button
          text={isEdit ? 'Save' : 'Create'}
          typeBtn={'contained'}
          contained={'primary'}
          size={'medium'}
          disabled={disabled || loading || !canManageSavedReplies}
          tooltipProps={{
            label: savedRepliesPermissionError,
            placement: 'top',
          }}
          onClick={onCreate}
        />
      </div>
    </div>
  )
})
